import Link from 'next/link';

import { Typography } from 'lighthouse';

import { SafeImage } from '@/widgets/SafeImage';

import { GenerateFilePreviewUrl } from '@/utilities/GenerateFilePreviewUrl';

import MinimalProductCard from '../MinimalProductCard';
import { CartVendorGroupProps } from './models';

const CartVendorGroup = ({ cartId, provider, storeName, fulfillmentGroups }: CartVendorGroupProps) => {
    const displayName = storeName || 'فروشنده';
    const isAzkiService = displayName === 'ازکی‌سرویس';

    return (
        <div className='overflow-hidden bg-white'>
            <Link
                href={`/vendor/${provider}`}
                className='flex items-center gap-2 border-b border-solid border-gray-100 bg-gray-50 px-3 py-2 transition-colors hover:bg-gray-100'>
                <figure className='m-0 h-7 w-7 shrink-0 overflow-hidden rounded-md bg-white ring-1 ring-gray-200'>
                    <SafeImage
                        src={
                            isAzkiService
                                ? '/images/logo/Azkiservice-single-logo.png'
                                : GenerateFilePreviewUrl({
                                      attachableId: provider,
                                      attachment: 'STORE',
                                      type: 'LOGO',
                                      isPrimary: true,
                                      sortOrder: 0
                                  }).src
                        }
                        alt={displayName}
                        fallback='/images/vendor/vendor_profile_default.png'
                        className='h-7 w-7 object-cover'
                        width={28}
                        height={28}
                    />
                </figure>

                <Typography className='line-clamp-1 text-xs text-blackMediumEmphasis'>
                    فروشنده:&nbsp;
                    <span className='font-semibold text-primary'>{displayName}</span>
                </Typography>
            </Link>

            <div className='divide-y divide-gray-100'>
                {fulfillmentGroups.map((fulfillment) =>
                    fulfillment.items.map((product) => <MinimalProductCard key={cartId + product.itemId} cartId={cartId} data={product} compact />)
                )}
            </div>
        </div>
    );
};

export default CartVendorGroup;
